import { iPlace } from './../../model/iPlace';
import { Sale } from './sale';
import { PetrolSalesService } from './petrol-sales.service';
import { Component, OnInit } from '@angular/core';
import * as Highcharts from 'highcharts/highstock';
import HC_exporting_data from 'highcharts/modules/export-data';
import HC_exporting from 'highcharts/modules/exporting';
import HC_xrange from 'highcharts/modules/xrange';
import { BsDatepickerConfig } from 'ngx-bootstrap/datepicker';
import { IPlaceService } from './../../iPlace/iPlace.service';
import { I18NService } from './../../shared/i18n/i18n.service';

HC_exporting(Highcharts);
HC_exporting_data(Highcharts);
HC_xrange(Highcharts);

class Selectable {
  public id: string;
  public value: string;
}

const fuels = {
  "90": "Gasóleo A",
  "91": "Adblue",
  "92": "Gasóleo C",
  "93": "Gasóleo A Plus",
  "94": "Gasóleo B",
  "95": "Sin Plomo 95",
  "97": "Sin Plomo 95 Premium",
  "98": "Sin Plomo 98",
  "99": "GLP",
}

@Component({
  selector: 'petrol-sales',
  templateUrl: './petrol-sales.component.html',
  styleUrls: ['./petrol-sales.component.css']
})
export class PetrolSalesComponent implements OnInit {
  selectableStations: any[] = [];
  selectedStations: any[] = [];
  dropdownSettings: any;
  dropdownSettingsSimple: any;
  dateRangeFilter: any;
  updateFromInput: boolean = false;
  bsConfig: Partial<BsDatepickerConfig>;

  Highcharts: typeof Highcharts = Highcharts;
  chartConstructor: string = 'chart';
  chart: Highcharts.Chart;
  chartCallback: Highcharts.ChartCallbackFunction;
  isLoading: boolean = true;

  chartArray: any[] = [];

  constructor(private iPlaceService: IPlaceService, private i18nService: I18NService, private petrolSalesService: PetrolSalesService) {
    const self = this;

    this.dropdownSettings = {
      singleSelection: false,
      primaryKey: 'id',
      labelKey: 'iPlaceName',
      selectAllText: i18nService.get("selectAll"),
      unSelectAllText: i18nService.get("unselectAll"),
      filterSelectAllText: i18nService.get("selectAllFiltered"),
      filterUnSelectAllText: i18nService.get("unselectAllFiltered"),
      noDataLabel: i18nService.get("noResults"),
      text: i18nService.get("selectiPlaces"),
      searchPlaceholderText: i18nService.get("search"),
      badgeShowLimit: 2,
      enableSearchFilter: true,
      groupBy: null,
      classes: "form-angular2-multiselect"
    };

    this.bsConfig = Object.assign({}, { containerClass: "theme-custom right", showWeekNumbers: false });

    let startDate = new Date();
    startDate.setHours(0, 0, 0, 0);
    let endDate = new Date();
    endDate.setHours(0, 0, 0, 0);
    endDate = new Date(endDate.getTime() - 604800000);
    this.dateRangeFilter = [endDate, startDate];
  }

  ngOnInit() {
    this.iPlaceService
      .get()
      .then(iplaces => {
        this.selectableStations = iplaces;
      })
      .catch(err => {
        console.error("NO IPLACES");
      });
  }

  loadData() {
    const self = this;
    this.isLoading = true;
    this.chartArray = [];
    let endDateMillis = this.dateRangeFilter[1].getTime() + 86400000;//Dia siguiente

    this.petrolSalesService.getSales({
      iPlaceIds: this.selectedStations.map(station => station.id),
      dateStartMillis: this.dateRangeFilter[0].getTime(),
      dateEndMillis: endDateMillis,
      tz: 'Europe/Madrid'
    }).then((sales: Sale[]) => {
      let groupedDataByProduct = this.groupBy(sales, 'productId');
      for (const key in groupedDataByProduct) {
        if (groupedDataByProduct.hasOwnProperty(key)) {
          const salesByProduct = groupedDataByProduct[key];
          let fuelChar = {
            name: fuels[key],
            productId: key,
            chartOptions: this.getBaseConfig(fuels[key])
          }
          fuelChar.chartOptions.series = this.buildData(salesByProduct);
          this.chartArray.push(fuelChar);
        }
      }

      self.updateFromInput = true;

      this.isLoading = false;
    }).catch((err) => {
      this.isLoading = false;
    })

  }

  buildData(sales: Sale[]) {
    let stationsData = [];
    let groupedData = this.groupBy(sales, 'iPlaceId');

    this.selectedStations.forEach(iPlace => {
      let stationData = {
        name: iPlace.iPlaceName,
        type: 'column',
        data: groupedData[iPlace.idiPlace] ? groupedData[iPlace.id].map((sale) => {
          return [
            sale.time,
            sale.volumeTotal ? (Math.round(sale.volumeTotal * 100) / 100) : 0
          ]
        }) : [],
        tooltip: {
          valueSuffix: ' l'
        }
      };
      stationsData.push(stationData);
    });

    return stationsData;
  }

  groupBy(xs, key) {
    return xs.reduce(function (rv, x) {
      (rv[x[key]] = rv[x[key]] || []).push(x);
      return rv;
    }, {});
  };

  onItemSelect() {
    this.loadData();
  }

  onSelectAll() {
    this.loadData();
  }

  onDateRangeChange(any: any) {
    this.loadData();
  }
  onFuelChange(any: any) {
    this.loadData();
  }

  itemDeSelect(item, property) {
    this[property] = [item];
  }

  clearFilters() {
    let startDate = new Date();
    startDate.setHours(23, 59, 59, 999);
    let endDate = new Date();
    endDate.setHours(0, 0, 0, 0);
    endDate = new Date(endDate.getTime() - 604800000);
    this.dateRangeFilter = [endDate, startDate];
    this.selectedStations = [];
    this.loadData();
  }

  getBaseConfig(name: string) {

    return {
      credits: {
        enabled: false
      },
      legend: {
        useHTML: true,
        // layout: 'vertical',
        // align: 'right',
        // verticalAlign: 'center',
        // floating: false,
        // y: 30,
        adjustChartSize: true,
        labelFormatter: function () {
          const reducer = (accumulator, currentValue) => accumulator + currentValue;
          let total = this.yData.reduce(reducer, 0);
          let roundTotal = Math.round(total * 100) / 100;
          return `${this.name}<br> Total: ${roundTotal}l<br>`;
        }
      },
      title: {
        text: name
      },
      xAxis: {
        type: 'datetime'
      },
      labels: {
        formatter: function () {
          let roundTotal = Math.round(this.value * 100) / 100;
          return ` ${roundTotal}l`;
        },
      },
      exporting: {
        menuItemDefinitions: {
          // Custom definition
        },
        buttons: {
          contextButton: {
            menuItems: ["viewFullscreen", "printChart", "separator", "downloadPNG", "separator", "downloadCSV", "downloadXLS"]
          }
        }
      },
      yAxis: [{ // Primary yAxis
        title: {
          text: this.i18nService.get("litersSold"),
          style: {
            color: Highcharts.getOptions().colors[1]
          }
        }
      }] as Highcharts.Options,

      series: []
    };
  }
}
